export default __webpack_public_path__ + "images/QV.a955ab2.png";